'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var React = require('react');
var Typography_web = require('../../atoms/Typography/Typography.web.cjs');
var InternalCheckbox_web = require('../../internal/InternalCheckbox/InternalCheckbox.web.cjs');
var InternalRadio_web = require('../../internal/InternalRadio/InternalRadio.web.cjs');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
require('../../../../../../_virtual/index.cjs');
var useInputFocus = require('../../../utils/hooks/useInputFocus.cjs');
var SelectableTile_web_styles = require('./SelectableTile.web.styles.cjs');

/**
 * A clickable tile for single or multiple selection. Acts as a visually prominent alternative to radio buttons or checkboxes.
 *
 * {@link https://aviary.fullscript.io/latest/components/selectable-tile/web-bCb0lVWa | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/SelectableTile/SelectableTile.web.tsx | View in GitLab}
 *
 * @scope Web
 */ const SelectableTile = ({ children, input, label, disabled = false, rightContent, customCss, "data-testid": dataTestId, ...props })=>{
    const theme = react.useTheme();
    const { isKeyboardFocused, handleFocus, handleBlur } = useInputFocus.useInputFocus();
    const memoizedStyles = React.useMemo(()=>({
            container: [
                SelectableTile_web_styles.container(theme),
                SelectableTile_web_styles.removeInputFocusRing,
                isKeyboardFocused && SelectableTile_web_styles.selectableTileFocusRing(theme),
                disabled && SelectableTile_web_styles.disabled(theme),
                customCss
            ],
            content: SelectableTile_web_styles.content
        }), [
        theme,
        isKeyboardFocused,
        disabled,
        customCss
    ]);
    const renderContent = React.useMemo(()=>/*#__PURE__*/ jsxRuntime.jsxs("div", {
            css: memoizedStyles.content,
            children: [
                /*#__PURE__*/ jsxRuntime.jsxs("div", {
                    children: [
                        /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                            variant: "body",
                            fontWeight: "bold",
                            isMarginless: true,
                            children: label
                        }),
                        children
                    ]
                }),
                /*#__PURE__*/ jsxRuntime.jsx("div", {
                    children: rightContent
                })
            ]
        }), [
        label,
        children
    ]);
    if (input === "radio") {
        return /*#__PURE__*/ jsxRuntime.jsx(InternalRadio_web.InternalRadio, {
            disabled: disabled,
            onFocus: handleFocus,
            onBlur: handleBlur,
            labelStyle: memoizedStyles.container,
            "data-testid": dataTestId || "aviary-selectable-tile",
            ...props,
            children: renderContent
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx(InternalCheckbox_web.InternalCheckbox, {
        disabled: disabled,
        onFocus: handleFocus,
        onBlur: handleBlur,
        labelStyle: memoizedStyles.container,
        isFullWidth: true,
        "data-testid": dataTestId || "aviary-selectable-tile",
        ...props,
        children: renderContent
    });
};
SelectableTile.displayName = "SelectableTile";

exports.SelectableTile = SelectableTile;
//# sourceMappingURL=SelectableTile.web.cjs.map
